module.exports = __webpack_public_path__ + "static/Srinivasa-3-460aa2930a9b21587939fe0d3433f6ee.jpeg";